import { parseStores } from "@src/libs/parser";

export const stores = parseStores(
	require.context("./", true, /\.(store)\.(js)$/)
);
